module.exports = __webpack_public_path__ + "images/icon-top-tel---3cf43d044f3b99442163c827c404fce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app/images/icon-top-tel.png
// module id = 389
// module chunks = 0